import { render, staticRenderFns } from "./DowntimeView.vue?vue&type=template&id=4457bc6c&scoped=true&"
import script from "./DowntimeView.vue?vue&type=script&lang=js&"
export * from "./DowntimeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4457bc6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4457bc6c')) {
      api.createRecord('4457bc6c', component.options)
    } else {
      api.reload('4457bc6c', component.options)
    }
    module.hot.accept("./DowntimeView.vue?vue&type=template&id=4457bc6c&scoped=true&", function () {
      api.rerender('4457bc6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/downtime/DowntimeView.vue"
export default component.exports